import { useSelector } from "react-redux";
import Text from "../text/Text";
import classes from './PageHeader.module.css';

const PageHeader = ({ text, children, color }) => {

    return (
        <div className={classes.Header} style={{ backgroundColor: color || "#f7f7f7" }}>
            <Text className={classes.Title}>{text}</Text>
            {children}
        </div>
    )
};
export default PageHeader;